import React, { useState, useEffect } from "react";
import axios from "axios";
import { HiPlus, HiPencil, HiTrash } from "react-icons/hi";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as bootstrap from "bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Customergroup() {
  const [groups, setGroups] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Base URL for API
  const API_BASE_URL = "http://localhost:5890";

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/customergroup`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      setGroups(response.data);
    } catch (error) {
      console.error("Error fetching groups:", error);
      toast.error("Failed to load customer groups");
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setGroupName("");
    setEditId(null);
  };

  const handleSaveGroup = async () => {
    if (!groupName.trim()) {
      toast.warn("Please enter a customer group name");
      return;
    }

    setIsSaving(true);
    const token = sessionStorage.getItem("token");

    try {
      if (editId) {
        // Update existing group
        await axios.put(
          `${API_BASE_URL}/customergroup/${editId}`,
          { name: groupName },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        toast.success("Customer group updated successfully");
      } else {
        // Add new group
        await axios.post(
          `${API_BASE_URL}/customergroup`,
          { name: groupName },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        toast.success("Customer group added successfully");
      }

      // Close modal and refresh data
      document.getElementById("closeModalBtn").click();
      resetForm();
      fetchGroups();
    } catch (error) {
      console.error("Error saving group:", error);
      const errorMessage = error.response?.data?.error || "Failed to save customer group";
      toast.error(errorMessage);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this customer group?")) {
      return;
    }

    try {
      await axios.delete(`${API_BASE_URL}/customergroup/${id}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      });
      toast.success("Customer group deleted successfully");
      fetchGroups();
    } catch (error) {
      console.error("Error deleting group:", error);
      const errorMessage = error.response?.data?.error || "Failed to delete customer group";
      toast.error(errorMessage);
    }
  };

  const filteredGroups = groups.filter((g) =>
    g.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container my-4">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="bg-white shadow rounded-4 p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="fw-bold text-dark m-0">Customer Groups</h3>
          <button
            className="btn btn-success d-flex align-items-center gap-2"
            data-bs-toggle="modal"
            data-bs-target="#groupModal"
            onClick={resetForm}
          >
            <HiPlus /> Add Customer Group
          </button>
        </div>

        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search Customer Group..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="table-responsive">
          {isLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <table className="table table-striped align-middle">
              <thead className="table-light">
                <tr>
                  <th width="10%">S.No</th>
                  <th width="70%">Customer Group</th>
                  <th width="20%">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredGroups.length > 0 ? (
                  filteredGroups.map((group, index) => (
                    <tr key={group.id || group._id}>
                      <td>{index + 1}</td>
                      <td>{group.name}</td>
                      <td>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => {
                              setEditId(group.id || group._id);
                              setGroupName(group.name);
                              new bootstrap.Modal(
                                document.getElementById("groupModal")
                              ).show();
                            }}
                            title="Edit"
                          >
                            <HiPencil />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(group.id || group._id)}
                            title="Delete"
                          >
                            <HiTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center text-muted py-4 fst-italic">
                      No customer groups found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Modal for Add/Edit */}
      <div
        className="modal fade"
        id="groupModal"
        tabIndex="-1"
        aria-labelledby="groupModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 shadow">
            <div className="modal-header bg-success text-white rounded-top-4">
              <h5 className="modal-title" id="groupModalLabel">
                {editId ? "Edit Customer Group" : "Add Customer Group"}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
              ></button>
            </div>
            <div className="modal-body">
              <label className="form-label fw-semibold">Customer Group Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter customer group name"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSaveGroup();
                  }
                }}
              />
              <small className="text-muted">Press Enter to save</small>
            </div>
            <div className="modal-footer bg-light rounded-bottom-4">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSaveGroup}
                disabled={isSaving || !groupName.trim()}
              >
                {isSaving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {editId ? "Updating..." : "Saving..."}
                  </>
                ) : editId ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}